import ArrowRight from "../src/arrow-right.svg";
import ChevronDown from "../src/chevron-down.svg";
import ChevronUp from "../src/chevron-up.svg";
import ChevronRight from "../src/chevron-right.svg";
import ChevronLeft from "../src/chevron-left.svg";
import Loading from "../src/loading.svg";
import Mail from "../src/mail.svg";
import Phone from "../src/phone.svg";
import Search from "../src/search.svg";
import Eye from "../src/eye.svg";
import Print from "../src/print.svg";
import FileDownload from "../src/file-download.svg";
import Close from "../src/close.svg";
import Menu from "../src/menu.svg";
import MapMarker from "../src/map-marker.svg";
import FilterFunnel from "../src/filter-funnel.svg";
import CheckboxChecked from "../src/checkbox-checked.svg";
import CheckboxUnchecked from "../src/checkbox-unchecked.svg";
import Paperclip from "../src/paperclip.svg";
import Calendar from "../src/calendar.svg";
import ClipboardCheck from "../src/clipboard-check.svg";
import { StyleSize } from "../../../common/models";

export type IconName =
  | "arrow-right"
  | "loading"
  | "chevron-down"
  | "chevron-up"
  | "chevron-right"
  | "chevron-left"
  | "mail"
  | "phone"
  | "search"
  | "eye"
  | "print"
  | "file-download"
  | "close"
  | "menu"
  | "map-marker"
  | "filter-funnel"
  | "checkbox-checked"
  | "checkbox-unchecked"
  | "paperclip"
  | "calendar"
  | "clipboard-check";

export const getIconSvg = (name: IconName, size: StyleSize = "default") => {
  const sizeClassName = {
    small: "sm:h-[16px] sm:w-[16px]",
    default: "sm:h-[24px] sm:w-[24px]",
    big: "h-[24px] w-[24px] sm:h-[24px] sm:w-[24px]",
    extra: "h-[40px] w-[40px] sm:h-[32px] sm:w-[32px]",
  };

  const svgClassName = `h-[16px] w-[16px] ${sizeClassName[size]}`;

  switch (name) {
    case "arrow-right":
      return <ArrowRight className={svgClassName} key="arrow-right" />;
    case "chevron-down":
      return <ChevronDown className={svgClassName} key="chevron-down" />;
    case "chevron-up":
      return <ChevronUp className={svgClassName} key="chevron-up" />;
    case "chevron-left":
      return <ChevronLeft className={svgClassName} key="chevron-left" />;
    case "chevron-right":
      return <ChevronRight className={svgClassName} key="chevron-right" />;
    case "loading":
      return <Loading className={svgClassName} key="loading" />;
    case "mail":
      return <Mail className={svgClassName} key="mail" />;
    case "phone":
      return <Phone className={svgClassName} key="phone" />;
    case "search":
      return <Search className={svgClassName} key="search" />;
    case "eye":
      return <Eye className={svgClassName} key="eye" />;
    case "print":
      return <Print className={svgClassName} key="print" />;
    case "file-download":
      return <FileDownload className={svgClassName} key="file-download" />;
    case "close":
      return <Close className={svgClassName} key="close" />;
    case "menu":
      return <Menu className={svgClassName} key="menu" />;
    case "map-marker":
      return <MapMarker key="map-marker" />; // used on map, we are using original dimensions
    case "filter-funnel":
      return <FilterFunnel className={svgClassName} key="filter-funnel" />;
    case "checkbox-checked":
      return (
        <CheckboxChecked className={svgClassName} key="checkbox-checked" />
      );
    case "checkbox-unchecked":
      return (
        <CheckboxUnchecked className={svgClassName} key="checkbox-unchecked" />
      );
    case "paperclip":
      return <Paperclip className={svgClassName} key="paperclip" />;
    case "calendar":
      return <Calendar className={svgClassName} key="calendar" />;
    case "clipboard-check":
      return <ClipboardCheck className={svgClassName} key="clipboard-check" />;
  }
};
